import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { SignalMetadataDto } from '../../dto';
import { BaseApiService } from './base-api.service';
import { catchError, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SignalMetadataApiService {
  private readonly url: string = 'service/contactcloud/growth-signals';
  private cached$?: Observable<SignalMetadataDto[]>;

  constructor(private readonly baseApiService: BaseApiService) {}

  getSignalMetadata(): Observable<SignalMetadataDto[]> {
    return this.baseApiService.get<SignalMetadataDto[]>(this.url, { showError: true });
  }

  /**
   * Cached Growth Signals metadata request.
   * Avoids duplicate calls across multiple components (sidebar + constructor).
   */
  getSignalMetadataCached(): Observable<SignalMetadataDto[]> {
    if (!this.cached$) {
      this.cached$ = this.getSignalMetadata().pipe(
        shareReplay({ bufferSize: 1, refCount: false }),
        catchError((err) => {
          this.cached$ = undefined;
          return throwError(() => err);
        }),
      );
    }
    return this.cached$;
  }
}

